import { BookingV4Component } from "@/app/infrastructures/dependencies/modules/BookingV4Component";
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { BookingV4Presenter } from "../presenters/BookingV4Presenter";
import {
  ManualBookingV4Retail,
  GetEstimationPriceV4,
  // GetBookingVoucherListV4,
  // ValidateBookingVoucherCodeV4,
  // IssueVoucherBookingOtpRequestV4,
  // CancelVoucherBookingReserveRequestV4,
  ProductConfigurationRuleRequestParamsV4,
  RequestListCommodityV4,
  ExchangeRateParamsV4,
  CorporateBookingV4Client
} from "@/data/payload/api/BookingV4Request";
import { PayloadPosterProduct } from "@/domain/entities/Booking";
import { ExchangeRateBookingV4 } from "@/domain/entities/BookingV4";

BookingV4Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "booking-v4"
})
class BookingV4Store extends VuexModule {
  // GENESIS-19589 — Est. CIPL exchange rate: rate aktif per pair currency, null saat kosong/error/belum fetch
  public activeExchangeRate: ExchangeRateBookingV4 | null = null;
  public activeExchangeRateRequestKey = "";

  @Mutation
  public setActiveExchangeRate(data: ExchangeRateBookingV4 | null) {
    this.activeExchangeRate = data;
  }

  @Mutation
  public setActiveExchangeRateRequestKey(key: string) {
    this.activeExchangeRateRequestKey = key;
  }

  @Action
  public addManualBooking(payload: ManualBookingV4Retail) {
    return container.resolve(BookingV4Presenter).addManualBooking(payload);
  }

  @Action
  public addBookingCorporate(payload: CorporateBookingV4Client) {
    return container.resolve(BookingV4Presenter).addBookingCorporate(payload);
  }

  @Action
  public getEstimationPrice(payload: GetEstimationPriceV4) {
    return container.resolve(BookingV4Presenter).getEstimationPrice(payload);
  }

  /*
  @Action
  public getBookingVoucherList(payload: GetBookingVoucherListV4) {
    return container.resolve(BookingV4Presenter).getBookingVoucherList(payload);
  }

  @Action
  public validateBookingVoucherCode(payload: ValidateBookingVoucherCodeV4) {
    return container
      .resolve(BookingV4Presenter)
      .validateBookingVoucherCode(payload);
  }

  @Action
  public issueVoucherBookingOtp(payload: IssueVoucherBookingOtpRequestV4) {
    return container
      .resolve(BookingV4Presenter)
      .issueVoucherBookingOtp(payload);
  }

  @Action
  public cancelVoucherBookingReserve(
    payload: CancelVoucherBookingReserveRequestV4
  ) {
    return container
      .resolve(BookingV4Presenter)
      .cancelVoucherBookingReserve(payload);
  }
  */

  @Action
  public postToGetPosterProduct(payload: PayloadPosterProduct) {
    return container
      .resolve(BookingV4Presenter)
      .postToGetPosterProduct(payload);
  }

  @Action
  public fetchProductConfigurationRule(
    params: ProductConfigurationRuleRequestParamsV4
  ) {
    return container
      .resolve(BookingV4Presenter)
      .fetchProductConfigurationRule(params);
  }

  @Action
  public getCommodityList(params: RequestListCommodityV4) {
    return container.resolve(BookingV4Presenter).getCommodityList(params);
  }

  // GENESIS-19589 — Exchange rate (Est. CIPL); repository already non-blocking (resolves null on error)
  @Action
  public async fetchActiveExchangeRate(params: ExchangeRateParamsV4) {
    const requestKey = `${params.from}|${params.to}`;
    this.setActiveExchangeRateRequestKey(requestKey);
    this.setActiveExchangeRate(null);
    try {
      const result = await container
        .resolve(BookingV4Presenter)
        .getActiveExchangeRate(params);
      if (this.activeExchangeRateRequestKey === requestKey) {
        this.setActiveExchangeRate(result);
      }
      return result;
    } catch {
      if (this.activeExchangeRateRequestKey === requestKey) {
        this.setActiveExchangeRate(null);
      }
      return null;
    }
  }

  @Action
  public clearActiveExchangeRate() {
    this.setActiveExchangeRateRequestKey("");
    this.setActiveExchangeRate(null);
  }

  // GENESIS-20970 — Saved package customer (sender-side)
  @Action
  public getSavedPackage(customerId: number) {
    return container.resolve(BookingV4Presenter).getSavedPackage(customerId);
  }

  @Action
  public getSavedPackageDetail(params: {
    customerId: number;
    packageId: number;
  }) {
    return container
      .resolve(BookingV4Presenter)
      .getSavedPackageDetail(params.customerId, params.packageId);
  }
}

export const BookingV4Controller = getModule(BookingV4Store);
